module.exports = __webpack_public_path__ + "static/media/SDG12.59d8737a.mp4";